import React from 'react';
import {
  Box,
} from '@mui/material';
import { GroundTruthMultiChoiceWithText, QuestionMultiChoiceWithText } from '../../redux/types';

type Props = {
  payload: GroundTruthMultiChoiceWithText['payload'];
  question: QuestionMultiChoiceWithText;
};

const GTMultiChoiceWithTextScore: React.FC<Props> = ({
  question,
  payload,
}: Props) => {
  const getStrictScoreList = (
    q: QuestionMultiChoiceWithText,
    p: GroundTruthMultiChoiceWithText['payload'],
  ) => {
    const list = q.payload?.filter((op) => {
      const { score } = p.truths[op.id] || {};
      return !!score;
    }).map((op) => op.text);
    return list;
  };

  const getScoreList = (
    q: QuestionMultiChoiceWithText,
    p: GroundTruthMultiChoiceWithText['payload'],
  ) => {
    const list = q.payload?.filter((op) => {
      const { score } = p.truths[op.id] || {};
      return !!score;
    }).map((op) => `${op.text} (${p.truths[op.id].score})`);
    return list;
  };

  return (
    <Box sx={{ whiteSpace: 'pre-wrap' }}>
      {
        payload.strict && (
          <Box>
            {
              getStrictScoreList(question, payload)?.map((i) => (
                <Box key={i}>
                  {i}
                </Box>
              ))
            }
            (
              {payload.score}
            )
          </Box>
        )
      }
      {
        !payload.strict && (
          <Box>
            {
              getScoreList(question, payload)?.map((i) => (
                <Box key={i}>
                  {i}
                </Box>
              ))
            }
          </Box>
        )
      }
    </Box>
  );
};

export default GTMultiChoiceWithTextScore;
